module.exports = require("./cy.d.ts");